<script setup lang="ts">
import { IconProps } from './IconProps';

withDefaults(defineProps<IconProps>(), {
  width: 33,
  height: 28,
  viewBox: '0 0 33 28',
  background: 'none',
  color: 'black',
  opacity: 0.32,
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :fill="background"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7494 9C15.7494 9.82843 15.0778 10.5 14.2494 10.5C13.421 10.5 12.7494 9.82843 12.7494 9C12.7494 8.17157 13.421 7.5 14.2494 7.5C15.0778 7.5 15.7494 8.17157 15.7494 9Z"
      :fill="color"
      :fill-opacity="opacity"
    />
    <path
      d="M15.7494 14C15.7494 14.8284 15.0778 15.5 14.2494 15.5C13.421 15.5 12.7494 14.8284 12.7494 14C12.7494 13.1716 13.421 12.5 14.2494 12.5C15.0778 12.5 15.7494 13.1716 15.7494 14Z"
      :fill="color"
      :fill-opacity="opacity"
    />
    <path
      d="M20.7494 14C20.7494 14.8284 20.0778 15.5 19.2494 15.5C18.421 15.5 17.7494 14.8284 17.7494 14C17.7494 13.1716 18.421 12.5 19.2494 12.5C20.0778 12.5 20.7494 13.1716 20.7494 14Z"
      :fill="color"
      :fill-opacity="opacity"
    />
    <path
      d="M15.7494 19C15.7494 19.8284 15.0778 20.5 14.2494 20.5C13.421 20.5 12.7494 19.8284 12.7494 19C12.7494 18.1716 13.421 17.5 14.2494 17.5C15.0778 17.5 15.7494 18.1716 15.7494 19Z"
      :fill="color"
      :fill-opacity="opacity"
    />
    <path
      d="M20.7494 19C20.7494 19.8284 20.0778 20.5 19.2494 20.5C18.421 20.5 17.7494 19.8284 17.7494 19C17.7494 18.1716 18.421 17.5 19.2494 17.5C20.0778 17.5 20.7494 18.1716 20.7494 19Z"
      :fill="color"
      :fill-opacity="opacity"
    />
    <path
      d="M20.7494 9C20.7494 9.82843 20.0778 10.5 19.2494 10.5C18.421 10.5 17.7494 9.82843 17.7494 9C17.7494 8.17157 18.421 7.5 19.2494 7.5C20.0778 7.5 20.7494 8.17157 20.7494 9Z"
      :fill="color"
      :fill-opacity="opacity"
    />
  </svg>
</template>
